import React, { useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import Typography from "@mui/material/Typography";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import IconButton from "@mui/material/IconButton";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "@mui/material";
import { fetchAvatars } from "../../redux/actions/avatarsActionCreators";

export default function AvatarModal({ open, handleClose, handleSelect }) {
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const avatars = useSelector((state) => state.avatars.avatars);

  useEffect(() => {
    dispatch(fetchAvatars());
  }, [dispatch]);

  const isMobile = useMediaQuery("(max-width:1400px)");

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="xl"
        PaperProps={{
          sx: !isMobile
            ? { width: "35%", padding: "20px " }
            : { width: "90%", height: "90%", margin: "5px 0", padding: "5px " },
        }}
      >
        <Typography
          variant="subtitle3"
          sx={{ display: "flex", alignItems: "center", mb: 1 }}
        >
          <IconButton onClick={handleClose}>
            <KeyboardBackspaceIcon sx={{ width: "70%", color: "black" }} />
          </IconButton>
          {t("back")}
        </Typography>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            gap: 10,
          }}
        >
          {avatars.map((el, index) => (
            <div
              key={`${el}-${index}`}
              className="avatar"
              onClick={() => handleSelect(el)}
            >
              <img
                alt=""
                src={el}
                style={{
                  width: "100px",
                  height: "100px",
                  objectFit: "contain",
                }}
              />
            </div>
          ))}
        </div>
      </Dialog>
    </div>
  );
}
